import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Sale & Delivery plan'
  }
];

@Component({
  selector: 'page-sale-delivery-plan',
  templateUrl: './plan-sale.html',
  styleUrls: ['./plan-sale.scss']
})

export class PagePlanSale implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  cksearch:boolean=false;
  form: FormGroup;

  approve_items=[];
  approve_levels=[];
  users = [];
  rows = [];
  temp=[];
  lines=[];
  month_selected:any;
  key:any="";

  data:any;

  loadingIndicator: boolean = true;
  id:string;
  ckedit:boolean=false;
  picture:String;
  //upload file
  imageSrc:any;

  Name:string; 
  myFile:File; /* property of File type */
  dialogRefWarning: MdDialogRef<WarningsaleDeliveryPlanDialog>;
  dialogRef: MdDialogRef<saleDeliveryPlanDialog>;
  setId:any;
  sysPath:String=environment.sysPath;
  sysPathPrint:String=environment.sysPath+"/api/approve-list-print.php";
  sysPathExport:String=environment.sysPath+"/api/approve-list-export.php";


  dropdownList = [];
  selectedItems = [];
  shift_selected:any;
  shiftItems = [
    { value: '1', viewValue: 'Day' },
    { value: '2', viewValue: 'Night' },
   
  ];

  //dropdownSettings = {};
  dropdownSettings = { 
    singleSelection: false, 
    text:"Select",
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    classes:"col-md-12"
  };  

  date_selected:any;
  delivery_date_selected:any;
  delivery_round:any;
  time_selected:any;
  time_selected_stop:any;
  qty:any=0;sort:any=0;
  constructor(private fb: FormBuilder,private httpservice:httpservice,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
  
  let date = new Date();
  this.date_selected = date.toISOString().split('T')[0];
  this.month_selected = date.toISOString().split('T')[0];

  this.delivery_date_selected = date.toISOString().split('T')[0];

  this.getCustomer();
  this.getStartData();
    this._sharedService.emitChange(this.pageTitle);
  }

onItemSelect(item:any){}
OnItemDeSelect(item:any){}
onSelectAll(items: any){}
onDeSelectAll(items: any){}

  intervalGetData(){
    return setInterval(() => {
      if(this.setId.runCount>5){
      clearInterval(this.setId);
      }
      this.getStartData();
      console.log('------this.setId------',this.setId.runCount);
     }, 1000);
  }



  getCustomer(){
    this.httpservice.fetchget('getJSON_customer.php?type=2',(data)=>{
     // this.products = data;
     console.log('menu',data);
      for(let i = 0;i<data.length;i++){
        this.dropdownList.push({"id":data[i].tc_id,"itemName":data[i].tc_company_shortname});
      }
    });
  }

  search(){
    this.loadingIndicator = true;
    this.httpservice.fetchget('getJSON_sale_delivery_plan.php?key='+this.month_selected,data=>{
      this.rows = data;
      this.temp = data;
      this.loadingIndicator = false;
      console.log('------this.cksearch------',this.cksearch);
    })
  }
  getStartData(){

    this.httpservice.fetchget('getJSON_sale_delivery_plan.php?',(data) => {
      this.rows = data;
      this.temp = data;
      this.loadingIndicator = false;
      console.log('------this.cksearch------',this.cksearch);
    });
  }

  delete(id:string){
  let val = {id:id}
  this.httpservice.fetchpost('delete_sale_delivery.php', val, (cb) => {});
  this.getStartData();
  }

  setedit(id:string){
    this.cancelEdit();
    this.id = id;
    this.ckedit=true;
    this.httpservice.fetchget('getJSON_sale_delivery_plan.php?id='+id,(data) => {
      let tb132f_id:any;

      this.date_selected = data[0].tb132f_date;
      tb132f_id = data[0].tb132f_id;
      this.shift_selected = data[0].tb132f_shift;
      this.selectedItems = data[0].items;
      this.time_selected = data[0].tb132f_time;
      this.time_selected_stop = data[0].tb132f_time_stop;
      this.delivery_date_selected = data[0].tb132f_delivery_date;
      this.delivery_round = data[0].tb132f_delivery_round;
      this.qty = data[0].tb132f_qty;
      this.sort = data[0].tb132f_sort;
      console.log();
    });
  }

  edit(){
    this.setId = this.intervalGetData();
    this.ckedit = false;
    this.data = {
      id:this.id,
      delivery_date:this.delivery_date_selected,
      delivery_round:this.delivery_round,
      date_selected:this.date_selected,
      time_selected:this.time_selected,
      time_selected_stop:this.time_selected_stop,
      qty:this.qty,
      sort:this.sort,
      shift:this.shift_selected,
      items:this.selectedItems
    }
    // insert data
    this.httpservice.fetchpost('editSaleDeliveryPlan.php', this.data, (cb) => {
    //upload document
    this.getStartData();
    this.cancelEdit();
    });

  }

  cancelEdit(){
    this.ckedit = false;
    this.form.reset();
    this.selectedItems = [];

  }


save(){
  this.setId = this.intervalGetData();
  console.log('data_selected',this.date_selected);
  this.data = {
    delivery_date:this.delivery_date_selected,
    delivery_round:this.delivery_round,
    date_selected:this.date_selected,
    time_selected:this.time_selected,
    time_selected_stop:this.time_selected_stop,
    sort:this.sort,
    qty:this.qty,
    shift:this.shift_selected,
    items:this.selectedItems
  }
  // insert data
  this.httpservice.fetchpost('insertSaleDeliveryPlan.php', this.data, (cb) => {
  this.getStartData();
  this.cancelEdit();
  });

}


  ngOnInit() {
    this.form = this.fb.group({
        secret_code: [null, Validators.compose([Validators.required])],
        fileInput: [null, Validators.compose([Validators.required])],
        groupName: [null, Validators.compose([Validators.required])]
    });

  }

  attachFile(event) : void {
    var reader = new FileReader();
    let _self = this;

    reader.onload = function(e) {
      _self.imageSrc = reader.result;
      console.log(_self.imageSrc);
    };
    reader.readAsDataURL(event.target.files[0]);
    this.myFile = event.target.files[0];
   //this.uploadPhoto(event.target.files[0]);
   console.log('File name : ',this.myFile.name);
   }


  updateFilter_customer(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.customer.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }
  updateFilter_date(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.tb132f_date.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }
  updateFilter_time(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.tb132f_time.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }




  openDeleteDialog(id:string) {

    let dialogRef = this.dialog.open(saleDeliveryPlanDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to delete this?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
          this.delete(id);
        console.log('---result---',result,id);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }
  openEditDialog(){
    let dialogRef = this.dialog.open(saleDeliveryPlanDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.date_selected !=undefined && this.selectedItems.length>0){
          this.edit();
        }else{
          this.warningDialog('Please fill in group name, menu item');
        }
      
       // console.log('---result---',result,this.user_selected.value.length,this.form.controls.code.value,this.form.controls.name.value,this.form.controls.ct.value);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }
  openDialog(){
    let dialogRef = this.dialog.open(saleDeliveryPlanDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.date_selected !=undefined && this.selectedItems.length>0){
          this.save();
        }else{
          this.warningDialog('Please fill in date, select customer items');
        }
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }

  warningDialog(message: string) {

    let dialogRef = this.dialog.open(WarningsaleDeliveryPlanDialog);
    let instance = dialogRef.componentInstance;
    instance.message = message;
    instance.title = "Warning";

    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;

      if (result === '1') {

        // alert('postString');
      } else {
        console.log('---result---', result);
        // alert('cancel');
      }

    });
  }
}
//dialog
@Component({
  selector: 'pm-dialog',
  templateUrl: 'dialog.html',
})
export class saleDeliveryPlanDialog {
  title = '';
  message = '';
  constructor(public dialogRef: MdDialogRef<saleDeliveryPlanDialog>) {}
}

//warning
@Component({
  selector: 'warning-pm-dialog',
  templateUrl: 'warning.html',
})
export class WarningsaleDeliveryPlanDialog {
  title = '';
  message = '';
  constructor(public dialogRefWarning: MdDialogRef<WarningsaleDeliveryPlanDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/plan-sale/plan-sale.ts